import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { environment } from 'src/environments/environment.prod';



@Injectable({
  providedIn: 'root'
})
export class VideoAlbumService {
  public Data = new BehaviorSubject(null)
  constructor(private _HttpClient:HttpClient) { }
  GetVideoAlbum():Observable<any>{
    return this._HttpClient.get(`${environment.Server_URL}/VideoAlbum/Get`);
  }

  DeleteVideoAlbum(id):Observable<any>{
    return this._HttpClient.get(`${environment.Server_URL}/VideoAlbum/Delete?id=${id}`);
  }

  CreateVideoAlbum(data):Observable<any>{
    return this._HttpClient.post(`${environment.Server_URL}/VideoAlbum/Create`,data);
  }
  UpdateVideoAlbum(data):Observable<any>{
    return this._HttpClient.post(`${environment.Server_URL}/VideoAlbum/Update`,data)
  }
}
